import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import {V1ProjectPlanPhaseMilestoneReferenceIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";


class ProjectPlanPhaseReferenceEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhaseMilestoneReference-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhaseMilestoneReference-001t";

        let fk = {};
        fk["ProjectPlanPhaseUSID"] = foreignKey;

        AxiosFoundationAPI({
            method: "GET",
            url: "t1/v1/project_plan_phase_milestone_references",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneReferenceIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.ProjectPlanPhaseMilestoneReference-001";
        payload.PlatformMessage.ProjectPlanPhaseMilestoneReference = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t1/v1/project_plan_phase_milestone_references",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestoneReference-001",
                "idoc-response": "v1.ProjectPlanPhaseMilestoneReference-001",
            },
        };
        this.notifyUpdateStartListeners();
        AxiosFoundationAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneReferenceIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let reference = {};

        reference["USID"] = this.getAttributeValue("USID");
        reference["ReferenceType"] = this.getAttributeValue("ReferenceType");
        reference["DocumentRevisionUSID"] = this.getAttributeValue("DocumentRevisionUSID");
        reference["ProjectPlanPhaseMilestoneUSID"] = this.getAttributeValue("ProjectPlanPhaseMilestoneUSID");
        reference["Comment"] = this.getAttributeValue("Comment");

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.ProjectPlanPhaseMilestoneReference-001";
        payload.PlatformMessage.ProjectPlanPhaseMilestoneReference = reference;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t1/v1/project_plan_phase_milestone_references",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestoneReference-001",
                "idoc-response": "v1.ProjectPlanPhaseMilestoneReference-001",
            },
        };
        this.notifyInsertStartListeners();
        AxiosFoundationAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneReferenceIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.ProjectPlanPhaseMilestoneReference-001";
        payload.PlatformMessage.ProjectPlanPhaseMilestoneReference = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t1/v1/project_plan_phase_milestone_references",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseMilestoneReference-001",
                "idoc-response": "v1.ProjectPlanPhaseMilestoneReference-001",
            },
        };
        this.notifyDeleteStartListeners();
        AxiosFoundationAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default ProjectPlanPhaseReferenceEnterpriseComponent;